import React from "react";
import "../styles/InfoCatastro.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "../componentes/FileManager";

const InfoCatastro = () => {
  const { isAdmin } = useAuth();

  return (
      <div id="info-catastro" className="catastro-container">
        <div className="catastro-card">
          <div className="catastro-header">
            
            <h2 className="catastro-title">Normativas de Catastro e Información Territorial</h2>
          </div>

          <p className="catastro-text">
            Desde la <strong>Comuna de Progreso</strong>, ponemos a disposición las normativas vigentes para su consulta pública.
          </p>

          {/* El FileManager ahora maneja la subida y la lista con botones de borrar */}
          <FileManager
              tableName="catastro_files"
              folderName="catastro"
              isAdmin={isAdmin}
          />

          <div className="catastro-footer">
            <p>Para consultas técnicas, acercarse a la oficina comunal.</p>
          </div>
        </div>
      </div>
  );
};

export default InfoCatastro;